import React from 'react';
import { trackEvent, trackCall } from '../../utils/analytics';
import { WHATSAPP_BASE_URL, PHONE_TEL } from '../../constants/contact';

function ToolWhatsAppCTA({ title = "Need Expert Help?", description = "Our garden experts can help you with personalized advice.", whatsappMessage = "Hi! I need help with my garden." }) {
  const encodedMessage = encodeURIComponent(whatsappMessage);

  return (
    <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: '15px', background: 'linear-gradient(135deg, #25d366 0%, #128c7e 100%)' }}>
      <div className="card-body p-4 text-white">
        <h5 className="mb-2">
          <i className="icofont-headphone-alt me-2"></i>
          {title}
        </h5>
        <p className="mb-3 small" style={{ opacity: 0.9 }}>{description}</p>
        <a
          href={`${WHATSAPP_BASE_URL}?text=${encodedMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-light d-block mb-2"
          style={{ borderRadius: '25px', fontWeight: '600' }}
          onClick={() => trackEvent('whatsapp_lead', { button_text: 'Chat on WhatsApp', location: 'tool-whatsapp-cta' })}
        >
          <i className="icofont-whatsapp me-2" style={{ color: '#25d366' }}></i>
          Chat on WhatsApp
        </a>
        <a
          href={PHONE_TEL} onClick={() => trackCall('tool_cta')}
          className="btn btn-outline-light d-block"
          style={{ borderRadius: '25px' }}
        >
          <i className="icofont-phone me-2"></i>
          Call Us Now
        </a>
      </div>
    </div>
  );
}

export default ToolWhatsAppCTA;
